"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveUsersDataProvider = exports.useActiveUsersDataContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const ProjectDashboardDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/ProjectDashboardDataProvider");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const DashboardApiService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/DashboardApiService");
const ActiveUsersDataContext = React.createContext(undefined);
const useActiveUsersDataContext = () => {
    const context = React.useContext(ActiveUsersDataContext);
    if (!context) {
        throw new Error("useActiveUsersDataContext must be used within a ActiveUsersDataContext.Provider");
    }
    return context;
};
exports.useActiveUsersDataContext = useActiveUsersDataContext;
const ActiveUsersDataProvider = (props) => {
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const fetchActiveUsers = (0, react_1.useCallback)(async (lastNDays) => {
        try {
            if (process.env.NODE_ENV === "development") {
                console.log("ActiveUsersDataProvider: fetchActiveUsers", { lastNDays, projectApiKey });
            }
            const actorResult = await projectsContext.getActor(projectApiKey);
            if (!lodash_1.default.isNil(actorResult.error)) {
                console.warn("fetchActiveUsers failed. no actor", actorResult.error);
                // noinspection ExceptionCaughtLocallyJS
                throw actorResult.error;
            }
            else {
                const projectDashboardResultByChunks = (0, DashboardApiService_1.getProjectDashboardResultByChunks)(actorResult.actors, actorResult.accessToken, lastNDays);
                const projectDashboardResultByChunksFeatureState = await (0, DataProviderCommonTypes_1.getFeatureStateFromICPromise)(projectDashboardResultByChunks);
                return (0, ProjectDashboardDataProvider_1.calculateActiveUsersFeatureState)(projectDashboardResultByChunksFeatureState);
            }
        }
        catch (e) {
            throw e;
        }
        // noinspection ExceptionCaughtLocallyJS
        throw new Error("unknown");
    }, [projectApiKey]);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        fetchActiveUsers,
    }), [
        fetchActiveUsers,
    ], lodash_1.default.isEqual);
    return React.createElement(ActiveUsersDataContext.Provider, { value: value }, props.children);
};
exports.ActiveUsersDataProvider = ActiveUsersDataProvider;
